import type { ReactNode } from 'react'
import { useTheme } from '@/shared/core/hooks/use-theme/use-theme.ts'
import { GeometricShapes } from '@/teams/portfolio/components/geometric-shapes/geometric-shapes.tsx'

interface ThemeProviderProps {
	children: ReactNode
}

export function ThemeProvider({ children }: Readonly<ThemeProviderProps>) {
	useTheme()

	return (
		<>
			<GeometricShapes />
			{children}
		</>
	)
}
